import { render, staticRenderFns } from "./fermeture.vue?vue&type=template&id=424e8186&"
import script from "./fermeture.vue?vue&type=script&lang=js&"
export * from "./fermeture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports